export default "__VITE_ASSET__Bqx05HcQ__"